import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { TextField, Select, FormControl, MenuItem } from '@mui/material'
import Button from '@mui/material/Button';

import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay-ts';

import { getTodayDate, epochToHumanReadableTS, pretty_print_json } from '../components/Functions'

import axios from 'axios';
import AdminMenu from '../components/AdminMenu'

const columns_wakeup_data = [
    { field: 'timestamp', headerName: 'Time Stamp', width: 200 },
    { field: 'msg_id', headerName: 'Msg ID' },
    { field: 'epoch', headerName: 'Epoch' },
    { field: 'data', headerName: 'Data' , width: 300}
]

const columns_transactions_data = [
    { field: 'timestamp', headerName: 'Time Stamp', width: 200 },
    { field: 'epoch', headerName: 'Epoch' },
    { field: 'msg_id', headerName: 'Msg ID' },
    { field: 'req', headerName: 'Req' },
    { field: 'msg_no', headerName: 'Msg_NO' },
    { field: 'msg_cnt', headerName: 'Msg_CNT' },
    { field: 'data', headerName: 'DATA', width: 200 },
    { field: 'raw_msg', headerName: 'RAW', width: 200 }
]

var defaultDate = getTodayDate();

const AdminViewData = () => {

    let navigate = useNavigate();

    const [deviceList, setDeviceList] = useState([]);
    const [reqList, setReqList] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState("");
    const [formData, setFormData] = useState({
        "device_id": "",
        "data_type": "",
        "start_date": "",
        "end_date": ""
    })
    
    const [showWakeUpDataDiv, setShowWakeUpDataDiv] = useState("hidden")
    const [deviceWakeUpData, setDeviceWakeUpData] = useState([])
    
    const [showTransactionsDataDiv, setShowTransactionsDataDiv] = useState("hidden")
    const [deviceTransactionsData, setDeviceTransactionsData] = useState([])

    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading");

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    // Start up : Load the list of available devices
    useEffect(() => {
        const getDevices = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevices";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });
                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }
                console.log(response.data);
                // Set the retrieved data to the state
                setDeviceList(response.data);
                //setSelectedDevice(response.data[0].device_id);
                updateformDataState("device_id",response.data[0].device_id);
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                // setError(error);
               
            }
        };


        setLoadingActive(true);
        getDevices();
        updateformDataState("data_type", "TRANSACTIONS")
        updateformDataState("start_date", defaultDate)
        updateformDataState("end_date", defaultDate)
        setLoadingActive(false);

    }, [])

    function updateForm(e) {
        const form_target_list = [
            "device_id","data_type","start_date","end_date"
        ]

        console.log(e)


        if (form_target_list.includes(e.target.id)) {
            updateformDataState(e.target.id, e.target.value)
        }

        if (form_target_list.includes(e.target.name)) {
            updateformDataState(e.target.name, e.target.value)
        }
    }

    function updateformDataState(id, val) {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: val,
        }));

    }


    function loadBtnClick(e) {

        let url = process.env.REACT_APP_API_SERVER + "/loadData";
        let post_data = {}
        post_data.device_id = formData.device_id
        post_data.data_type = formData.data_type
        post_data.start_date = formData.start_date
        post_data.end_date = formData.end_date

        setLoadingActive(true)

        axios.post(url, post_data)
            .then(function (response) {
                let data = response.data;

                console.log(data)
                let tmp_array = []

                if (post_data.data_type === "WAKEUP"){
                    data.map((row) => {
                        let tmp_json = {}
                        tmp_json.id = row.id
                        tmp_json.epoch = row.epoch
                        tmp_json.timestamp = epochToHumanReadableTS(row.epoch)
                        tmp_json.msg_id = row.msg_id
                        tmp_json.data = JSON.stringify(row.data)
                        tmp_array.push(tmp_json)
    
                    });
                    setDeviceWakeUpData(tmp_array)
                    setShowWakeUpDataDiv("")    
                    setShowTransactionsDataDiv("hidden")             
                }

                if (post_data.data_type === "TRANSACTIONS"){
                    data.map((row) => {
                        let tmp_json = {}
                        tmp_json.id = row.id
                        tmp_json.epoch = row.epoch
                        tmp_json.timestamp = epochToHumanReadableTS(row.epoch)
                        tmp_json.msg_id = row.msg_id
                        tmp_json.msg_no = row.msg_no
                        tmp_json.msg_cnt = row.msg_cnt
                        tmp_json.req = row.req
                        tmp_json.data = JSON.stringify(row.data)
                        tmp_json.raw_msg = JSON.stringify(row.raw_msg)
                        tmp_array.push(tmp_json)
    
                    });
                    setDeviceTransactionsData(tmp_array)
                    setShowWakeUpDataDiv("hidden")     
                    setShowTransactionsDataDiv("")                
                }

                setLoadingActive(false)
            })
            .catch(function (error) {
                // setModalHeader("Error: Unable to Generate Report")
                // setModalBody(error)
                // setShowModal(true)
            });
    }

    function wakeUpDataRowClick(e){
        console.log(e)

        let jsonString = e.row.data
        const unescapedString = jsonString.replace(/\\\\/g, '\\');
        const jsonObject = JSON.parse(unescapedString);
        const prettyJsonString = JSON.stringify(jsonObject, null, 2);

        
        let tmp_html = `
        <div><b>Msg ID</b></div>
        <div>${e.row.msg_id}</div>
        <div><b>Data</b></div>
        <div>
        <pre>${prettyJsonString}</pre>
        </div>
        
        `
        console.log(tmp_html)
        setModalHeader(e.row.timestamp)
        setModalHtml(tmp_html)
        setShowModal(true)

    }

    function transactionsDataRowClick(e) {
        console.log(e)

        let data_json = e.row.data
        let raw_msg_json = e.row.raw_msg

        let tmp_html = `
        <div><b>Msg ID</b></div>
        <div>${e.row.msg_id}</div>
        <div><b>Data</b></div>
        <div>
        <pre>${pretty_print_json(data_json)}</pre>
        </div>
        <div><b>Raw Msg</b></div>
        <div>
        <pre>${pretty_print_json(raw_msg_json)}</pre>
        </div>
        
        `
        console.log(tmp_html)
        setModalHeader(e.row.timestamp)
        setModalHtml(tmp_html)
        setShowModal(true)

    }



    return (
        <div align="left" style={{ height: "100%", padding: "30px" }} className='admin_pages'>
            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingText}
                className="spinner_div"
            >
            
                <AdminMenu />

            <table>
                <tr>
                    <td> {/* Drop down menu to select device  */}   
                        <div className="form-labels-admin">Select Device</div>
                        <FormControl fullWidth>
                            <Select
                                id="device_id"
                                name="device_id"
                                label="Select Device"
                                value = { formData.device_id }
                                variant="outlined"
                                onChange={updateForm}
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    ' & .MuiSelect-select': { fontSize: 14 }
                                }}
                            >
                                {
                                    deviceList.map(device => {
                                        return <MenuItem key={device.device_id} value={device.device_id}>
                                            {device.device_id}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </td>
                    <td width="10px"></td>
                    <td> {/* Drop down menu to select data_type  */}
                        <div className="form-labels-admin">Select Data Type</div>
                        <FormControl fullWidth>
                            <Select
                                id="data_type"
                                name="data_type"
                                label="Select Data Type"
                                    value={formData.data_type}
                                variant="outlined"
                                onChange={updateForm}
                                sx={{
                                    width: "200px",
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    ' & .MuiSelect-select': { fontSize: 14 }
                                }}
                            >
                                    <MenuItem key='TRANSACTIONS' value='TRANSACTIONS'>TRANSACTIONS</MenuItem>
                                    <MenuItem key='WAKEUP' value='WAKEUP'>WAKEUP</MenuItem>

                            </Select>
                        </FormControl>
                    </td>
                        <td width="10px"></td>
                        <td>{/* Start Date */}
                        <div className="form-labels-admin">Start Date</div>

                        <TextField
                            id="start_date"
                            name="start_date"
                            type="date"
                            defaultValue={defaultDate}
                            onChange={updateForm}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                '& .MuiInputBase-input': { fontSize: 14 }
                            }}
                        />
                    </td>
                        <td width="10px"></td>
                    <td> {/* End Date  */}
                        <div className="form-labels-admin">End Date</div>

                        <TextField
                            id="end_date"
                            name="end_date"
                            type="date"
                            defaultValue={defaultDate}
                            onChange={updateForm}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                '& .MuiInputBase-input': { fontSize: 14 }
                            }}
                        />
                    </td>
                        <td width="10px"></td>
                        <td> {/* Load Button  */}
                        <Button
                            variant="contained"
                            color="success"
                            onClick={loadBtnClick}
                            sx={{ width: 100, height: 50 }}
                            style={{ marginTop: "20px" }}
                        >
                            Load
                        </Button>
                    </td>
                </tr>

            </table>


                {/* Data Grid -- Wakeup Data  */}
                <div className={showWakeUpDataDiv}>
                    <div style={{ height: 600, width: 800 }}>
                        <DataGrid
                            rows={deviceWakeUpData}
                            columns={columns_wakeup_data}
                            pageSize={50}
                            onRowClick={wakeUpDataRowClick}
                            disableVirtualization
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                            sx={{
                                '& .MuiTablePagination-selectLabel': {
                                    paddingTop: '15px'

                                },
                                '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                '& .MuiDataGrid-cell': { fontSize: 12 },
                                '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                    outline: 'none', // Remove outline when cell is focused or editing
                                    border: 'none', // Remove border when cell is focused or editing
                                }

                            }} />
                    </div>
                </div>

                {/* Data Grid -- Transactions Data  */}
                <div className={showTransactionsDataDiv}>
                    <div style={{ height: 600, width: 1200 }}>
                        <DataGrid
                            rows={deviceTransactionsData}
                            columns={columns_transactions_data}
                            pageSize={50}
                            onRowClick={transactionsDataRowClick}
                            disableVirtualization
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                            sx={{
                                '& .MuiTablePagination-selectLabel': {
                                    paddingTop: '15px'

                                },
                                '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                '& .MuiDataGrid-cell': { fontSize: 12 },
                                '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                    outline: 'none', // Remove outline when cell is focused or editing
                                    border: 'none', // Remove border when cell is focused or editing
                                }

                            }} />
                    </div>
                </div>


            <MuiDialogAlert
                showModal={showModal}
                handleClose={handleClose}
                html={modalHtml}
                bodyContent={modalBody}
                title={modalHeader}
                bodyClass="whitespace"
            />
            </LoadingOverlay>
        </div>
    )
}

export default AdminViewData